import { createMemo, onMount, createSignal, batch } from 'solid-js'
import { Portal } from 'solid-js/web'
import { res2json } from '@/utils'
import * as constants from '@lib/constants'
import * as games from '@games'
import { addToast } from '@/components/Toast'
import account from '@/store/account'

export default function RobotPlay() {
  const [loading, setLoading] = createSignal(true)

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>机器人消息规则</li>
          </ul>
        </div>
        <h2 class="text-xl">机器人消息规则</h2>
        <FanRobotPlay setLoading={setLoading} />
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}

function FanRobotPlay({ setLoading }) {
  const [fan, setFan] = createSignal('')
  const [zheng, setZheng] = createSignal('')
  const [nian, setNian] = createSignal('')
  const [jiao, setJiao] = createSignal('')
  const [dan, setDan] = createSignal('')
  const [shuang, setShuang] = createSignal('')
  const [da, setDa] = createSignal('')
  const [xiao, setXiao] = createSignal('')
  const [tong, setTong] = createSignal('')
  const [zhong, setZhong] = createSignal('')
  const [jia, setJia] = createSignal('')
  const [te, setTe] = createSignal('')
  const [teDan, setTeDan] = createSignal('')
  const [teShuang, setTeShuang] = createSignal('')
  const [teDa, setTeDa] = createSignal('')
  const [teXiao, setTeXiao] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  async function load() {
    setLoading(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-play`).then(res2json).then(r => {
      batch(() => {
        setFan(r.data?.fan ?? games.nob8.defaultRobotPlayFan)
        setZheng(r.data?.zheng ?? games.nob8.defaultRobotPlayZheng)
        setNian(r.data?.nian ?? games.nob8.defaultRobotPlayNian)
        setJiao(r.data?.jiao ?? games.nob8.defaultRobotPlayJiao)
        setDan(r.data?.dan ?? games.nob8.defaultRobotPlayDan)
        setShuang(r.data?.shuang ?? games.nob8.defaultRobotPlayShuang)
        setDa(r.data?.da ?? games.nob8.defaultRobotPlayDa)
        setXiao(r.data?.xiao ?? games.nob8.defaultRobotPlayXiao)
        setTong(r.data?.tong ?? games.nob8.defaultRobotPlayTong)
        setZhong(r.data?.zhong ?? games.nob8.defaultRobotPlayZhong)
        setJia(r.data?.jia ?? games.nob8.defaultRobotPlayJia)
        setTe(r.data?.te ?? games.nob8.defaultRobotPlayTe)
        setTeDan(r.data?.te_dan ?? games.nob8.defaultRobotPlayTeDan)
        setTeShuang(r.data?.te_shuang ?? games.nob8.defaultRobotPlayTeShuang)
        setTeDa(r.data?.te_da ?? games.nob8.defaultRobotPlayTeDa)
        setTeXiao(r.data?.te_xiao ?? games.nob8.defaultRobotPlayTeXiao)
      })
    }).finally(() => { setLoading(false) })
  }
  onMount(() => {
    load()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return false
    }
    setErrors({})
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-play`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fan: fan(),
        zheng: zheng(),
        nian: nian(),
        jiao: jiao(),
        dan: dan(),
        shuang: shuang(),
        da: da(),
        xiao: xiao(),
        tong: tong(),
        zhong: zhong(),
        jia: jia(),
        te: te(),
        te_dan: teDan(),
        te_shuang: teShuang(),
        te_da: teDa(),
        te_xiao: teXiao(),
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        addToast({ message: '已保存' })
      }
    }).finally(() => { setSending(false) })
  }

  async function reset() {
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-play`, {
      method: 'DELETE'
    }).then(res2json).then(() => load()).then(() => {
      addToast({ message: '已重置' })
    }).finally(() => { setSending(false) })
  }

  return (
    <form onSubmit={submit} class="overflow-x-auto">
      <table class="table whitespace-nowrap">
        <thead>
          <tr class="bg-base-200">
            <th>玩法</th>
            <th>消息规则</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>番</td>
            <td>
              <textarea rows="6" value={fan()} onChange={e => setFan(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().fan && (<div class="label"><span class="label-text-alt text-error">{errors().fan}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>正</td>
            <td>
              <textarea rows="6" value={zheng()} onChange={e => setZheng(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().zheng && (<div class="label"><span class="label-text-alt text-error">{errors().zheng}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>念</td>
            <td>
              <textarea rows="6" value={nian()} onChange={e => setNian(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().nian && (<div class="label"><span class="label-text-alt text-error">{errors().nian}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>角</td>
            <td>
              <textarea rows="6" value={jiao()} onChange={e => setJiao(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().jiao && (<div class="label"><span class="label-text-alt text-error">{errors().jiao}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>单</td>
            <td>
              <textarea rows="6" value={dan()} onChange={e => setDan(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().dan && (<div class="label"><span class="label-text-alt text-error">{errors().dan}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>双</td>
            <td>
              <textarea rows="6" value={shuang()} onChange={e => setShuang(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().shuang && (<div class="label"><span class="label-text-alt text-error">{errors().shuang}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>大</td>
            <td>
              <textarea rows="6" value={da()} onChange={e => setDa(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().da && (<div class="label"><span class="label-text-alt text-error">{errors().da}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>小</td>
            <td>
              <textarea rows="6" value={xiao()} onChange={e => setXiao(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().xiao && (<div class="label"><span class="label-text-alt text-error">{errors().xiao}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>通</td>
            <td>
              <textarea rows="6" value={tong()} onChange={e => setTong(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().tong && (<div class="label"><span class="label-text-alt text-error">{errors().tong}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>中</td>
            <td>
              <textarea rows="6" value={zhong()} onChange={e => setZhong(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().zhong && (<div class="label"><span class="label-text-alt text-error">{errors().zhong}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>加</td>
            <td>
              <textarea rows="6" value={jia()} onChange={e => setJia(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().jia && (<div class="label"><span class="label-text-alt text-error">{errors().jia}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>特码</td>
            <td>
              <textarea rows="6" value={te()} onChange={e => setTe(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().te && (<div class="label"><span class="label-text-alt text-error">{errors().te}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>特码-单</td>
            <td>
              <textarea rows="6" value={teDan()} onChange={e => setTeDan(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().te_dan && (<div class="label"><span class="label-text-alt text-error">{errors().te_dan}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>特码-双</td>
            <td>
              <textarea rows="6" value={teShuang()} onChange={e => setTeShuang(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().te_shuang && (<div class="label"><span class="label-text-alt text-error">{errors().te_shuang}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>特码-大</td>
            <td>
              <textarea rows="6" value={teDa()} onChange={e => setTeDa(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().te_da && (<div class="label"><span class="label-text-alt text-error">{errors().te_da}</span></div>)}
            </td>
          </tr>
          <tr>
            <td>特码-小</td>
            <td>
              <textarea rows="6" value={teXiao()} onChange={e => setTeXiao(e.target.value)} class="textarea textarea-bordered w-full"></textarea>
              {errors().te_xiao && (<div class="label"><span class="label-text-alt text-error">{errors().te_xiao}</span></div>)}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="grid grid-cols-2 md:grid-cols-5 gap-4 pt-4">
        <div class="hidden md:block md:col-span-3"></div>
        <button type="button" onClick={() => reset()} class="btn w-full" disabled={sending()}>重置预设值</button>
        <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>保存</button>
      </div>
    </form>
  )
}
